export default "/8522fe2631ecefb1e3967be9883671f05392a386/b552ae94a3baa9664c4076d726380c66.svg";